export function getSpecs(specificationBlocks: any, lang: string) {
	if (!specificationBlocks) return []

	if (lang === 'en_US' && specificationBlocks.Imperial) {
		return Object.keys(specificationBlocks.Imperial).map((key) => ({
			[key]: specificationBlocks.Imperial[key],
		}))
	} else if (lang !== 'en_US' && specificationBlocks.Metric) {
		return Object.keys(specificationBlocks.Metric).map((key) => ({
			[key]: specificationBlocks.Metric[key],
		}))
	} else if (specificationBlocks.Universal) {
		return Object.keys(specificationBlocks.Universal).map((key) => ({
			[key]: specificationBlocks.Universal[key],
		}))
	} else {
		return []
	}
}

export function getSpecsByUnit(
	specificationBlocks: any,
	unit: 'Metric' | 'Imperial',
) {
	if (unit === 'Imperial' && specificationBlocks.Imperial) {
		return Object.keys(specificationBlocks.Imperial).map((key) => ({
			[key]: specificationBlocks.Imperial[key],
		}))
	} else if (unit === 'Metric' && specificationBlocks.Metric) {
		return Object.keys(specificationBlocks.Metric).map((key) => ({
			[key]: specificationBlocks.Metric[key],
		}))
	} else if (specificationBlocks.Universal) {
		return Object.keys(specificationBlocks.Universal).map((key) => ({
			[key]: specificationBlocks.Universal[key],
		}))
	} else {
		return []
	}
}

export function getInlineSpecsByUnit(
	specificationBlocks: any,
	unit: 'Metric' | 'Imperial',
) {
	if (unit === 'Imperial' && specificationBlocks.Imperial) {
		return Object.values(specificationBlocks.Imperial).join(' · ')
	} else if (unit === 'Metric' && specificationBlocks.Metric) {
		return Object.values(specificationBlocks.Metric).join(' · ')
	} else if (specificationBlocks.Universal) {
		return Object.values(specificationBlocks.Universal).join(' · ')
	}
}
